import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { SettingField } from 'src/app/interfaces/database';
import { BlastTemplate } from 'src/app/interfaces/blast';

import { PrivilegeService } from 'src/app/services/account/privilege/privilege.service';
import { BlastTemplateService } from 'src/app/services/blast/blast-template.service';

import { PopupService } from 'src/app/services/general/popup.service';

import { BlastTemplateManageComponent } from '../blast-template-manage/blast-template-manage.component';
import { AccountEventModeService } from 'src/app/services/account/account-event-mode.service';

@Component({
  selector: 'app-blast-template-list',
  templateUrl: './blast-template-list.component.html',
  styleUrls: ['./blast-template-list.component.scss'],
})
export class BlastTemplateListComponent  implements OnInit, OnDestroy {

  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  /**
   * Content
   */
  @ViewChild('content', { read: ElementRef }) content: ElementRef;

  @Input() pageMode: boolean;
  @Input() templateTypeList: SettingField[];

  @Input() set ready(ready: boolean) {
    this.initial(ready);
  }

  slidePerView: number;

  selectMode: boolean;

  // swiperConfig: SwiperOptions;

  // private templateTypeSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private modalController: ModalController,
    private accountEventModeService: AccountEventModeService,
    private blastTemplateService: BlastTemplateService,
    private privilegeService: PrivilegeService,
    private popupService: PopupService,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
      // this.unwatchTemplateType();
  }

  initial(ready: boolean) {
    if (ready) {
      this.templateTypeList = this.blastTemplateService.setupStdTemplateTypeList();
      this.slidePerView = this.getSlidePerView();
    }
  }

  ionViewWillEnter() {
    this.initial(true);
  }

  ionViewWillLeave() {
    this.initial(false);
  }

  setupViewport() {
    if (this.cdkVirtualScrollViewport) {
      setTimeout(() => {
        this.cdkVirtualScrollViewport?.checkViewportSize();
      }, 200);
    } else {
      setTimeout(() => {
        this.setupViewport();
      }, 200);
    }
  }

  getSlidePerView() {
    const itemWidth = 90;
    const maxSlide = 4;

    let cardWidth = this.content?.nativeElement?.offsetWidth ? this.content.nativeElement.offsetWidth : window?.innerWidth;

    if (!this.pageMode) {
      cardWidth = cardWidth * 0.8;
      if (cardWidth > 600) {
        cardWidth = 600;
      }
    }

    let slidesPerView = Math.floor((cardWidth - 50) / itemWidth);
    if (!slidesPerView || slidesPerView < 1) {
      slidesPerView = 1;
    }

    if (slidesPerView >= maxSlide) {
      slidesPerView = maxSlide;
    } else {
      slidesPerView = slidesPerView + 0.5;
    }
    return slidesPerView;
  }

  /**
   * Dismiss modal
   */
  async dismissModal(blastTemplate?: BlastTemplate, blastCount?: number) {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { modal.dismiss({ blastTemplate, blastCount }); }
    }
  }

  async presentBlastTemplateManageModal(templateType?: SettingField) {
    if (this.checkPrivilege('send')) {
      const modal = await this.modalController.create({
        component: BlastTemplateManageComponent,
        cssClass: 'modal-full-screen-bk',
        componentProps: {
          templateType,
          templateNo: templateType?.value ? '1' : '',
          newMode: templateType?.value ? false : true,
          selectMode: this.selectMode
        }
      });
      modal.present();
      modal.onDidDismiss().then((result: any) => {
        if (result?.data?.blastTemplate && result.data.blastCount) {
          if (!this.pageMode) {
            this.dismissModal(result.data.blastTemplate, result.data.blastCount);
          }
        }
      });
    } else {
      this.popupService.presentAlert(this.translate.instant('ACCOUNT_PRIVILEGE.msg.no_privilege'));
    }
  }

  checkPrivilege(action: string): boolean {
    return this.privilegeService.checkCurrentUserPrivilege('blast', action);
  }

  trackByFn(index: number, item: SettingField) {
    if (item?.id) {
      return item?.id;
    } else if (item?.value) {
      return item?.value;
    }
    return index;
  }

  replaceEventType(text: string) {
    return this.accountEventModeService.replaceEventType(text);
  }

}
